import styled from 'styled-components';

import {ConferencePreview} from '@yourcoach/shared/modules/conference';
import {ms} from '@yourcoach/shared/styles/normalizeSize';

import ModalNew from '@src/components/ModalNew';

export const Modal = styled(ModalNew)`
  border-radius: ${ms(20)} !important;

  .Modal {
    display: flex;
    flex-direction: column;
    width: 50vw;
    min-width: 480px;
    max-width: 700px;
    height: 75vh;
    max-height: 700px;

    .body {
      padding: ${ms(24)} !important;
    }
  }
`;

export const ConferencePreviewContainer = styled(ConferencePreview)``;
